module.exports = __webpack_public_path__ + "static/media/shopping.72bc835e.jpg";